/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S2_P3Inputs */

const tr_hakkimizda_s2_p3 = /** @type {(inputs: Hakkimizda_S2_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ ürününü Emonse® E-Ticaret Limited Şirketi olarak doğrudan yürütüyoruz. Amacımız, Türkiye'de e-ticaret yapan şirketlerin ihtiyaç duyduğu teknolojiyi erişilebilir, tutarlı ve uzun vadede sürdürülebilir bir zeminde sunmak.`)
};

const en_hakkimizda_s2_p3 = /** @type {(inputs: Hakkimizda_S2_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We run the ShopPanel™ product directly as Emonse® E-Ticaret Limited Şirketi. Our aim is to provide the technology that companies doing e-commerce in Türkiye need on an accessible, consistent and long-term sustainable basis.`)
};

const de_hakkimizda_s2_p3 = /** @type {(inputs: Hakkimizda_S2_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Produkt ShopPanel™ betreiben wir als Emonse® E-Ticaret Limited Şirketi unmittelbar selbst. Unser Ziel ist es, die Technologie, die Unternehmen mit E-Commerce in der Türkei benötigen, auf einer zugänglichen, verlässlichen und langfristig nachhaltigen Grundlage bereitzustellen.`)
};

const ru_hakkimizda_s2_p3 = /** @type {(inputs: Hakkimizda_S2_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продукт ShopPanel™ мы ведём напрямую как Emonse® E-Ticaret Limited Şirketi. Наша цель состоит в том, чтобы предоставлять технологии, необходимые компаниям, занимающимся электронной коммерцией в Турции, на доступной, последовательной и устойчивой в долгосрочной перспективе основе.`)
};

/**
* | output |
* | --- |
* | "We run the ShopPanel™ product directly as Emonse® E-Ticaret Limited Şirketi. Our aim is to provide the technology that companies doing e-commerce in Türkiye ..." |
*
* @param {Hakkimizda_S2_P3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s2_p3 = /** @type {((inputs?: Hakkimizda_S2_P3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S2_P3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s2_p3(inputs)
	if (locale === "de") return de_hakkimizda_s2_p3(inputs)
	if (locale === "ru") return ru_hakkimizda_s2_p3(inputs)
	return tr_hakkimizda_s2_p3(inputs)
});